module.exports = __webpack_public_path__ + "img/1.ae9d946c.jpeg";